import React from 'react';
import { useTranslation } from 'react-i18next';

const Custobar: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="p-6">
      <div className="max-w-4xl mx-auto">
        <div className="flex flex-col items-center justify-center min-h-96 text-center">
          <div className="mb-8">
            <p className="text-xl text-gray-600 mb-2">{t('common.coming_soon')}</p>
            <p className="text-gray-500 max-w-md mx-auto">
              {t('integrations.custobar_description')}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Custobar;
